import { Routes, Route } from "react-router-dom";

import Home from "./containers/Home";
import About from "./containers/About";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import NotFound from "./containers/NotFound";
import Settings from "./containers/Settings";
import RegisterUser from "./containers/RegisterUser";
import UnregisterEmail from "./containers/UnregisterEmail";
import ResetPassword from "./containers/ResetPassword";
import ResetUserPassword from "./containers/ResetUserPassword";
import ChangePassword from "./containers/ChangePassword";
import UserAdminList from "./containers/UserAdminList";
import VerifyEmail from "./containers/VerifyEmail";
import LicenseList from "./containers/LicenseList";
import CreateOrganization from "./containers/CreateOrganization";
import SetupMfa from "./containers/SetupMfa";
import LicenseManagerList from "./containers/LicenseManagerList";

import AdminRoute from "./components/AdminRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import LicenseManagerRoute from "./components/LicenseManagerRoute";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<UnauthenticatedRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Signup />} />
        <Route path="/about" element={<About />} />
        <Route path="/login/reset" element={<ResetPassword />} />
        <Route path="/login/verify" element={<VerifyEmail />} />
      </Route>
      <Route element={<AuthenticatedRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/password" element={<ChangePassword />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/unregister" element={<UnregisterEmail />} />
        <Route path="/admin/password/reset" element={<ResetUserPassword />} />
        <Route path="/admin/register" element={<RegisterUser />} />
        <Route path="/admin/users" element={<UserAdminList />} />
      </Route>
      <Route element={<LicenseManagerRoute />}>
        <Route path="/admin/licenses" element={<LicenseList />} />
        <Route path="/admin/organizations/new" element={<CreateOrganization />} />
        <Route path="/admin/managers" element={<LicenseManagerList />} />
        <Route path="/admin/setup-mfa" element={<SetupMfa />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
